import React from 'react';
import { Box, Typography } from '@mui/material';
import * as styles from './styles';

function PublisherLogo({ logo, name, size = 48, logoColors, borderRadius }) {
    const gradient = logoColors?.length >= 2
        ? `linear-gradient(135deg, ${logoColors[0]}, ${logoColors[1]})`
        : 'linear-gradient(135deg, #0078FF, #00D7FF)';

    const initials = name
        ? name.split(' ').slice(0, 2).map((w) => w[0]).join('').toUpperCase()
        : '?';

    if (logo) {
        return (
            <Box
                component="img"
                src={logo}
                alt={name}
                sx={{ ...styles.image(size), ...(borderRadius && { borderRadius }) }}
            />
        );
    }

    return (
        <Box sx={{ ...styles.wrapper(size), background: gradient, ...(borderRadius && { borderRadius }) }}>
            <Typography sx={styles.initialsText(size)}>
                {initials}
            </Typography>
        </Box>
    );
}

export default PublisherLogo;
